<app-base-side-panel-modal class="h-dvh" [allowFooter]="false">
  <ng-template #header>
    <div class="flex justify-start items-center gap-3">
      <svg-icon class="w-8 h-8 text-navy-90" [src]="'in-review'"></svg-icon>

      <div class="text-navy-90">
        {{ buildTranslationKey('policy.view') | translate }}
      </div>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="shadow-sm border border-navy-50 rounded-md p-6 flex gap-4 flex-col bg-white">
      <div class="flex gap-3 items-start">
        <svg-icon class="policy-icon w-8.5 h-8.5" [src]="'policy-manager-green-bg'"></svg-icon>
        <div class="text-navy-90 text-2xl font-bold">{{ policy.name }}</div>
      </div>

      <app-formatted-text class="text-navy-70 text-base whitespace-pre-wrap" [text]="policy.description"></app-formatted-text>

      <div class="flex flex-col-reverse md:flex-col gap-4">
        @for (evidence of policy.evidence_files; track evidence.evidence_id) {
          <app-evidence-download-summary
            [evidence]="evidence"
            [downloadingResource]="DownloadingResource.Policies"
            [resourceId]="policy.id"
          ></app-evidence-download-summary>
        }

        <div class="flex flex-col gap-2 text-navy-90 text-base">
          <div>
            <span class="font-bold">{{ buildTranslationKey('lastApprovedOn') | translate }}</span>
            {{ policy.approval_time | localDate: dateFormat }}
          </div>

          <div>
            <span class="font-bold">{{ buildTranslationKey('approvedBy') | translate }}</span>
            {{ policy.approved_by }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-base-side-panel-modal>
